import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {CommonResponse} from "../response/common.response";
import {StorageOperadorRepository} from "../services/localstorage/usuario/storage.operador.repository";
import {ApiOperadorRepository} from "../services/api/operador/api.operador.repository";
import {OperadorEntity} from "../entity/operador.entity";

@Injectable({
    providedIn: 'root'
})
export class Operador extends OperadorEntity {
    PARAM = environment.PARAM;

    constructor(
        public apiOperadorRepository?: ApiOperadorRepository,
        public storageOperadorRepository?: StorageOperadorRepository
    ) {
        super();
    }

    /**
     * Armar el objeto en base a sus atributos: valor
     * Valido si el service 'OperadorService' esta inyectado y es un objeto,
     * para pasarlo como parametro en el constructor
     */
    public static build(data: {}, apiOperadorRepository?: ApiOperadorRepository) {
        const operador = new Operador();
        operador.apiOperadorRepository = apiOperadorRepository;
        for (const propiedad in data) {
            // @ts-ignore
            operador[propiedad] = data[propiedad];
        }
        return operador;
    }

    public async login(credenciales: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.login(credenciales);
    }

    public async aceptarTerminosYCondiciones(): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.aceptarTerminosYCondiciones();
    }


    public async deleteTokenByToken(): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.deleteTokenByToken(this.storageOperadorRepository.obtenerToken());
    }

    public async buscarClientesPorTexto(valorBusqueda: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.buscarClientesPorTexto(valorBusqueda);
    }

    public async getClientesPaginate(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiOperadorRepository.getClientesPaginate(objEnvio);
    }

    public async getTiposDocumentoCliente(): Promise<any> {
        // @ts-ignore
        return await this.apiOperadorRepository.getTiposDocumentoCliente();
    }
    public async getEstadosCliente(): Promise<any> {
        // @ts-ignore
        return await this.apiOperadorRepository.getEstadosCliente();
    }

    // ====================================
    // MÉTODOS PARA GESTIÓN DE CLIENTES
    // ====================================

    /**
     * Obtiene un cliente por su ID
     */
    public async getClienteById(clienteId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.getClienteById(clienteId);
    }

    /**
     * Crea un nuevo cliente
     */
    public async crearCliente(payload: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.crearCliente(payload);
    }

    /**
     * Actualiza un cliente existente
     */
    public async actualizarCliente(clienteId: any, payload: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.actualizarCliente(clienteId, payload);
    }


    /**
     * Obtiene los adjuntos de un cliente
     */
    public async getAdjuntosCliente(clienteId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.getAdjuntosCliente(clienteId);
    }



    /**
     * Elimina un adjunto de un cliente
     */
    public async eliminarAdjuntoCliente(archivoId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.eliminarAdjuntoCliente(archivoId);
    }

    /**
     * Consulta información de un RUC
     */
    public async consultarRuc(ruc: string): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.consultarRuc(ruc);
    }

    /**
     * Consulta información de un RUC
     */
    public async buscarClienteByRUC(ruc: string): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.buscarClienteByRUC(ruc);
    }



    public async getClienteListSearch(obj: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.getClienteListSearch(obj);
    }

    /**
     * Obtiene los documentos observados/rechazados de un cliente
     */
    public async getDocumentosObservadosCliente(clienteId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiOperadorRepository.getDocumentosObservadosCliente(clienteId);
    }

}
